export default __webpack_public_path__ + "static/media/animals.ac94f0da.png";